import {
    SET_SHAPE_SETS_TO_STORE,
    SET_RANDOM_PRODUCT,
    SET_RANDOM_PRODUCT_IS_LOADING,
    SET_GUIDES,
    createToast, SET_HELPER, SET_SELECTED_COMPARISON_ENGINE,
    SET_EDIT_MODE,
} from "actions"

import { ReduxList, Action, GuidesType, HelperType, EditModeType } from "app/types/app-types"
import { ShapeSet } from "app/types/model-types"
import _map from "lodash/map"
import { ACTIVE_VIEW_SHAPE_SELECTION, ActiveViewType } from "../template-edit/containers/Editor";
import toastFactory, { ResponseErrorType } from "app/helpers/toast_factory";
import store from "../store";
import { INVALID_FIELD_VALUE } from "../template-edit/reducers";
import { ComparisonEngineType } from "../diagnostics/diagnostics";
import { TOGGLE_LOCK_LAYER } from "../shape-list/reducers";

function checkIsValid(): boolean {
    const nodeList: NodeListOf<HTMLInputElement> = document.querySelectorAll<HTMLInputElement>('input[aria-invalid="1"][name^="templateForm.shapes."]')

    nodeList.forEach(function (element: HTMLInputElement) {
        if (element) {
            const name = element.getAttribute('name')!.replace('templateForm.shapes.', '').split('.')

            if (name.length > 0) {
                const error: ResponseErrorType = {
                    message: 'invalid_filed_value',
                    response: {
                        status: 400,
                        data: { index: name[0], name: name[1] },
                        headers: {},
                        statusText: '',
                    }
                }

                store.dispatch(createToast(toastFactory(INVALID_FIELD_VALUE, error)))
            }
        }
    });

    return (nodeList.length === 0)
}

export const SET_ACTIVE_VIEW = 'SET_ACTIVE_VIEW'
export function setActiveView(activeView: ActiveViewType): Action<ActiveViewType> {
    return {
        type: SET_ACTIVE_VIEW,
        payload: activeView
    }
}

export const SET_ACTIVE_SHAPE_ID = 'SET_ACTIVE_SHAPE_ID'
export function setActiveShapeId(activeShapeId: string): Action<string> {
    return {
        type: SET_ACTIVE_SHAPE_ID,
        payload: activeShapeId
    }
}

export const SET_ACTIVE_GROUP_ID = 'SET_ACTIVE_GROUP_ID'
export function setActiveGroupId(activeGroupId: string): Action<string> {
    return {
        type: SET_ACTIVE_GROUP_ID,
        payload: activeGroupId
    }
}

export type ShapeSets = ReduxList<ShapeSet>
const initialShapeSets: ShapeSets = {
    data: [],
    error: null,
    isLoaded: false,
    isLoading: false,
    updated: null,
}


//reducers:
export function shapeSetsReducer(shapeSets: ShapeSets = initialShapeSets, action: Action<any>): ShapeSets {
    switch (action.type) {
        case SET_SHAPE_SETS_TO_STORE:
            let data = _map(action.payload, (shapeset: any) => {
                return shapeset
            })
            return { ...shapeSets, ...{ data } }
        default:
            return shapeSets
    }
}

export function randomProductReducer(state: Object = {}, action: Action<any>): Object {
    switch (action.type) {
        case SET_RANDOM_PRODUCT_IS_LOADING:
            return { ...state, isLoading: action.payload }
        case SET_RANDOM_PRODUCT:
            return action.payload
        default:
            return state
    }
}

export const initialGuidesState: GuidesType = {
    isShowGuides: true,
    isShowGrid: false,
    isSnapOn: true,
    gridStep: 100,
    gridStepMode: 0,
    minApproachX: 10,
    minApproachY: 10,
}

export function guidesReducer(state: GuidesType = initialGuidesState, action: Action<GuidesType>): GuidesType {
    switch (action.type) {
        case SET_GUIDES:
            return action.payload
        default:
            return state
    }
}

export function editModeReducer(state: EditModeType = 'select', action: Action<EditModeType>): EditModeType {
    switch (action.type) {
        case SET_EDIT_MODE:
            return action.payload
        default:
            return state
    }
}

export function selectedOutputComparisonEngineReducer(state: ComparisonEngineType = null, action: Action<ComparisonEngineType>): ComparisonEngineType {
    switch (action.type) {
        case SET_SELECTED_COMPARISON_ENGINE:
            return action.payload
        default:
            return state
    }
}

const DefaultActiveView: ActiveViewType = ACTIVE_VIEW_SHAPE_SELECTION
export function activeViewReducer(state: ActiveViewType = DefaultActiveView, action: Action<ActiveViewType>): ActiveViewType {
    switch (action.type) {
        case SET_ACTIVE_VIEW:
            return action.payload
        default:
            return state
    }
}

export function activeShapeIdReducer(state: string = null, action: Action<any>): string {
    switch (action.type) {
        case SET_ACTIVE_SHAPE_ID:
            return action.payload
        case TOGGLE_LOCK_LAYER:
            return action.payload == state ? null : state
        default:
            return state
    }
}

export function activeGroupIdReducer(state: string = null, action: Action<any>): string {
    switch (action.type) {
        case SET_ACTIVE_GROUP_ID:
            return action.payload
        default:
            return state
    }
}

export const initialHelperState: HelperType = {
    isAllowed: true,
    isVisible: true,
    isMaximized: false,
    closedAt: null,
    className: '',
    title: null,
    text: null,
}

export function helperReducer(state: HelperType = initialHelperState, action: Action<any>): HelperType {
    switch (action.type) {
        case SET_HELPER:
            return action.payload
        default:
            return state
    }
}